export const BOUNTY_TYPES = {
  VOD: "Vod",
  TEXT: "Text",
}

export const AVAILABLE_BOUNTIES_PAGE_SIZE = 10

export const HIDDEN_BOUNTIES_LOCAL_STORAGE_KEY = "hidden-aimlabs-bounties"



// WEBPACK FOOTER //
// ./src/store/coach/dashboard/aimlabs-marketplace/bounties/bounties.constants.js